import React, { useEffect, useCallback, useState } from 'react'
import styled from 'styled-components'

// components
import Modal, { ModalProps } from '../../../components/bakery/Modal'
import ModalTitle from '../../../components/bakery/ModalTitle'
import useUserAsks from '../../../hooks/nft/useUserAsks'
import { MARKETTYPE, MARKETMULTITOKEN, MARKETTYPEV1 } from '../../../constants/bakery/nft'
import { BigNumber } from 'bignumber.js'
import { supportPetType, PetType } from '../../../constants/pet'

import { 
  getArtworks, 
  getArtworksV2, 
  getPets,
  getPetsV2,
  getBakeryCombos, 
  getBakeryCombosV2 
} from '../../../service/nft'
import { getWeapons, getWeaponsV2 } from '../../../service/weapon'
import { getPetEggs, getPetEggsV2 } from '../../../service/pet'

import { useActiveWeb3React } from '../../../hooks'
import { userExchangeNFTContract } from '../../../userType/userExchangeNFTContract'
import { userBidNFTContract } from '../../../userType/userBidNFTContract'
import { userNftAddress } from '../../../userType/userNftAddress'
import { multiTokenExchangeNftContract } from '../../../userType/multiTokenExchangeNftContract'
import { userMarketNameAll } from '../../../userType/userMarketNameAll'
import useYam from '../../../hooks/bakery/useYam'
import { cancelSellToken } from '../../../sushi/utils'
import { exchangeNFTsCancelSellToken } from '../../../sushi/exchangeNFTs'
import { useWeaponNftContract, useHelmetNftContract } from '../../../hooks/pets/useContract'
import { getHelmetInfo } from '../../../utils/lib/utils'
import { getPetImageUrl } from '../../../utils/func'
import { getWeaponInfo } from '../../../sushi/utils'
import { PET_BASE_URL } from '../../../constants/pets'


const ItemBtn = styled.div`
  background: linear-gradient(305.04deg, #FFD600 -43.12%, #FF7A00 70.33%);
  border-radius: 10px;
  font-family: Baloo Da;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  /* identical to box height */
  text-align: center;
  /* #FFF3E0 */
  color: #FFF3E0;
  min-width: 148px;
  padding: 0px 10px;
  height: 38px;
  line-height: 38px;
  text-align:center;
  cursor: pointer;
  margin: 20px auto;
`

const ItemSearchBtn = styled(ItemBtn)`
  background: linear-gradient(305.04deg, #fae681 -43.12%, #f5a052 70.33%);
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    animation: loading 1.2s linear infinite;
    -webkit-animation: loading 1.2s linear infinite;
    width: 15px;
    height: 15px;
    margin-left: 10px;
  }
  @keyframes loading {
    from {transform: rotate(0) }
    to { transform: rotate(360deg) }
  }
`

const Content = styled.div``

const ArtworkLists = styled.div`
  display: flex;
  justify-content:flex-start;
  align-items: center;
  flex-wrap: wrap;
  height: 400px;
  overflow: auto;
`

const ArtworkItem = styled.div`
  width: 33.33%;
  text-align: center;
  position: relative;
  position: relative;
  overflow: hidden;
  border-top-left-radius: 10px;
`

const VersionIcon = styled.img`
  width: 43px;
  height: 24px;
  position: absolute;
  top: -2px;
  left: 0px;
  z-index: 1;
`


const VideoArtwork = styled.video`
  width: 177px;
  height: 222px;
  border-radius: 20px;
`

const IconArtwork = styled.img`
  width: 177px;
  height: 222px;
  border-radius: 20px;
  background: #ffffff;
`

const MarketLabel = styled.div`
  margin-top: 5px;
  margin-bottom: 10px;
  display:flex;
  justify-content: flex-start;
  align-items: center;
`

const MarketIcon = styled.img`
  width: 15px;
  height: 15px;
`

const MarketName = styled.div`
  font-family: Baloo Da;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #AC562A;
  margin-left: 10px;

`

interface RevokeAllModalProps extends ModalProps {
}

const RevokeAllModal: React.FC<RevokeAllModalProps> = ({
  onDismiss,
}) => {
  const [requestedList1, setRequestedList1] = useState(false)
  const [requestedList2, setRequestedList2] = useState(false)

  const { account, chainId } = useActiveWeb3React()
  const sushi = useYam()

  // 是否有数据
  const [hasList, setHasList] = useState(false)

  const weaponNftContract = useWeaponNftContract()
  const helmetNftContract = useHelmetNftContract()

  // v1 v2合约 tokenid
  const emptyArray: any[] = []
  const [allMyAsks1, setAllMyAsks1] = useState(emptyArray)
  const [allMyAsks2, setAllMyAsks2] = useState(emptyArray)
  const [allMyAsks, setAllMyAsks] = useState(emptyArray)

  // v1 v2api数据
  // v1大多数nft api
  const [allMyMostAsksApi1, setAllMyMostAsksApi1] = useState(emptyArray)
  // v1 pet api
  const [allMyPetAsksApi1, setAllMyPetAsksApi1] = useState(emptyArray)
  // v1 weapon api
  const [allMyWeaponAsksApi1, setAllMyWeaponAsksApi1] = useState(emptyArray)
  // v1 egg api
  const [allMyEggAsksApi1, setAllMyEggAsksApi1] = useState(emptyArray)
  // v1 combo api
  const [allMyComboAsksApi1, setAllMyComboAsksApi1] = useState(emptyArray)

  // v2大多数nft api
  const [allMyMostAsksApi2, setAllMyMostAsksApi2] = useState(emptyArray)
  // v2 pet api
  const [allMyPetAsksApi2, setAllMyPetAsksApi2] = useState(emptyArray)
  // v2 weapon api
  const [allMyWeaponAsksApi2, setAllMyWeaponAsksApi2] = useState(emptyArray)
  // v2 egg api
  const [allMyEggAsksApi2, setAllMyEggAsksApi2] = useState(emptyArray)
  // v2 combo api
  const [allMyComboAsksApi2, setAllMyComboAsksApi2] = useState(emptyArray)


  // 所有nft市场数据
  const [allMyAsksApi, setAllMyAsksApi] = useState(emptyArray)

  // BSC Artists
  const bscArtistsAsks1 = useUserAsks(MARKETTYPE.BAKERYARTWORK)
  const bscArtistsAsks2 = useUserAsks(MARKETTYPE.BAKERYBSCARTWORK)
  const bscArtistsAsks3 = useUserAsks(MARKETTYPEV1.BAKERYARTWORKV1)
  const bscArtistsAsks4 = useUserAsks(MARKETTYPEV1.BAKERYBSCARTWORKV1)

  // KAKA NFT
  const kakaNft = useUserAsks(MARKETMULTITOKEN.KAKAMULTITOKEN)


  // Radio Caca NFT
  const radioCacaNft1 = useUserAsks(MARKETTYPE.RACANFT)
  const radioCacaNft2 = useUserAsks(MARKETMULTITOKEN.RACAMULTITOKEN)
  const radioCacaNft3 = useUserAsks(MARKETMULTITOKEN.MATRIXMULTITOKEN)
  const radioCacaNft4 = useUserAsks(MARKETMULTITOKEN.BAKEMUSKMIXERMULTITOKEN)

  // Tokau NFT
  const tokauNft = useUserAsks(MARKETMULTITOKEN.TOKAUMULTITOKEN)

  // LoveNFT
  const loveNft = useUserAsks(MARKETTYPE.LOVE)
  const loveNft1 = useUserAsks(MARKETTYPEV1.LOVEV1)

  // SafeNFT
  const safeNft = useUserAsks(MARKETTYPE.SFPARTWORK)
  const safeNft1 = useUserAsks(MARKETTYPEV1.SFPARTWORKV1)

  // Musk&Doge
  const muskNft = useUserAsks(MARKETTYPE.MUSKDOGE)
  const muskNft1 = useUserAsks(MARKETTYPEV1.MUSKDOGEV1)

  // 1inch&BAKE
  const inchNft = useUserAsks(MARKETTYPE.ONEINCH)
  const inchNft1 = useUserAsks(MARKETTYPEV1.ONEINCHV1)

  // BAKE&Banana
  const bananaNft = useUserAsks(MARKETTYPE.MEME)
  const bananaNft1 = useUserAsks(MARKETTYPEV1.MEMEV1)

  // BTC Artworks
  const btcNft = useUserAsks(MARKETTYPE.BTCARTWORK)
  const btcNft1 = useUserAsks(MARKETTYPEV1.BTCARTWORKV1)

  // Seascape
  const seascapeNft = useUserAsks(MARKETTYPE.SEASCAPE)
  const seascapeNft1 = useUserAsks(MARKETTYPEV1.SEASCAPEV1)

  // Binance NFT
  const binanceNft = useUserAsks(MARKETTYPE.BINANCENFT)
  const binanceNft1 = useUserAsks(MARKETTYPEV1.BINANCENFTV1)

  // TKO NFT
  const tkoNft = useUserAsks(MARKETTYPE.TKONFT)
  const tkoNft1 = useUserAsks(MARKETTYPEV1.TKONFTV1)

  // YooShi NFT
  const yooshiNft = useUserAsks(MARKETTYPE.YOOSHINFT)
  const yooshiNft1 = useUserAsks(MARKETTYPEV1.YOOSHINFTV1)

  // Bondly NFT
  const bondlyNft = useUserAsks(MARKETTYPE.BONDLYNFT)
  const bondlyNft1 = useUserAsks(MARKETTYPEV1.BONDLYNFTV1)

  // Alchemy Toys
  const toyNft = useUserAsks(MARKETMULTITOKEN.TOYMULTITOKEN)

  // Crypto Doggies
  const doggyNft = useUserAsks(MARKETTYPE.DOGGYNFT)
  const doggyNft1 = useUserAsks(MARKETTYPEV1.DOGGYNFTV1)

  // Barking NFT
  const barkingNft = useUserAsks(MARKETTYPE.BARKNFT)
  const barkingNft1 = useUserAsks(MARKETTYPEV1.BARKNFTV1)

  // Doggy Equipment
  const doggyEquipmentNft = useUserAsks(MARKETMULTITOKEN.EQUIPMENTMULTITOKEN)

  // Poker NFT
  const pokerNft = useUserAsks(MARKETMULTITOKEN.POKERMULTITOKEN)

  // Rare Car
  const carNft = useUserAsks(MARKETTYPE.CARNFT)

  // Bakery Combos
  const comboNft = useUserAsks(MARKETTYPE.DISH)
  const comboNft1 = useUserAsks(MARKETTYPEV1.DISHV1)

  // BakerySoccer
  const soccerNft = useUserAsks(MARKETTYPE.BAKERYSOCCER)
  const soccerNft1 = useUserAsks(MARKETTYPEV1.BAKERYSOCCERV1)

  // Battle Pets
  const battlePetNft = useUserAsks(MARKETTYPE.PETNFT)
  const battlePetNft1 = useUserAsks(MARKETTYPEV1.PETNFTV1)

  // Weapons
  const weaponNft = useUserAsks(MARKETTYPE.WEAPONNFT)
  const weaponNft1 = useUserAsks(MARKETTYPEV1.WEAPONNFTV1)

  // Pet Eggs
  const petEggNft = useUserAsks(MARKETTYPE.EGGNFT)
  const petEggNft1 = useUserAsks(MARKETTYPEV1.EGGNFTV1)

  const getMyAllAsks1 = useCallback(async () => {
    let mybscArtistsAsks3 = await bscArtistsAsks3()
    mybscArtistsAsks3 = mybscArtistsAsks3.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.BAKERYARTWORKV1,
        nftType: 3,
        ids: '3-' + d[0]
      }
    })
    let mybscArtistsAsks4 = await bscArtistsAsks4()
    mybscArtistsAsks4 = mybscArtistsAsks4.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.BAKERYBSCARTWORKV1,
        nftType: 111,
        ids: '111-' + d[0]
      }
    })
    let myloveNft1 = await loveNft1()
    myloveNft1 = myloveNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.LOVEV1,
        nftType: 105,
        ids: '105-' + d[0]
      }
    })
    let mysafeNft1 = await safeNft1()
    mysafeNft1 = mysafeNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.SFPARTWORKV1,
        nftType: 101,
        ids: '101-' + d[0]
      }
    })
    let mymuskNft1 = await muskNft1()
    mymuskNft1 = mymuskNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.MUSKDOGEV1,
        nftType: 4,
        ids: '4-' + d[0]
      }
    })
    let myinchNft1 = await inchNft1()
    myinchNft1 = myinchNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.ONEINCHV1,
        nftType: 8,
        ids: '8-' + d[0]
      }
    })
    let mybananaNft1 = await bananaNft1()
    mybananaNft1 = mybananaNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.MEMEV1,
        nftType: 5,
        ids: '5-' + d[0]
      }
    })
    let mybtcNft1 = await btcNft1()
    mybtcNft1 = mybtcNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.BTCARTWORKV1,
        nftType: 1,
        ids: '1-' + d[0]
      }
    })
    let myseascapeNft1 = await seascapeNft1()
    myseascapeNft1 = myseascapeNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.SEASCAPEV1,
        nftType: 6,
        ids: '6-' + d[0]
      }
    })
    let mybinanceNft1 = await binanceNft1()
    mybinanceNft1 = mybinanceNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.BINANCENFTV1,
        nftType: 2,
        ids: '2-' + d[0]
      }
    })
    let mytkoNft1 = await tkoNft1()
    mytkoNft1 = mytkoNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.TKONFTV1,
        nftType: 7,
        ids: '7-' + d[0]
      }
    })
    let myyooshiNft1 = await yooshiNft1()
    myyooshiNft1 = myyooshiNft1.map(d => {
      return {
        id: d[0],
        version: 1,
        MARKETTYPE: MARKETTYPEV1.YOOSHINFTV1,
        nftType: 109,
        ids: '109-' + d[0]
      }
    })
    let mybondlyNft1 = await bondlyNft1()
    mybondlyNft1 = mybondlyNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.BONDLYNFTV1,
        nftType: 110,
        ids: '110-' + d[0]
      }
    })
    let mydoggyNft1 = await doggyNft1()
    mydoggyNft1 = mydoggyNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.DOGGYNFTV1,
        nftType: 104,
        ids: '104-' + d[0]
      }
    })
    let mybarkingNft1 = await barkingNft1()
    mybarkingNft1 = mybarkingNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.BARKNFTV1,
        nftType: 108,
        ids: '108-' + d[0]
      }
    })
    let mycomboNft1 = await comboNft1()
    mycomboNft1 = mycomboNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.DISHV1,
        nftType: 10,
        ids: '10-' + d[0]
      }
    })
    let mysoccerNft1 = await soccerNft1()
    mysoccerNft1 = mysoccerNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.BAKERYSOCCERV1,
        nftType: 100,
        ids: '100-' + d[0]
      }
    })
    let mybattlePetNft1 = await battlePetNft1()
    mybattlePetNft1 = mybattlePetNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.PETNFTV1,
        nftType: 13,
        ids: '13-' + d[0]
      }
    })
    let myweaponNft1 = await weaponNft1()
    myweaponNft1 = myweaponNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.WEAPONNFTV1,
        nftType: 12,
        ids: '12-' + d[0]
      }
    })
    let mypetEggNft1 = await petEggNft1()
    mypetEggNft1 = mypetEggNft1.map(d => {
      return {
        id: d[0], 
        version: 1,
        MARKETTYPE: MARKETTYPEV1.EGGNFTV1,
        nftType: 11,
        ids: '11-' + d[0]
      }
    })
    const allMyAsks1 = [
      ...mybscArtistsAsks3,
      ...mybscArtistsAsks4,
      ...myloveNft1,
      ...mysafeNft1,
      ...mymuskNft1,
      ...myinchNft1,
      ...mybananaNft1,
      ...mybtcNft1,
      ...myseascapeNft1,
      ...mybinanceNft1,
      ...mytkoNft1,
      ...myyooshiNft1,
      ...mybondlyNft1,
      ...mydoggyNft1,
      ...mybarkingNft1,
      ...mycomboNft1,
      ...mysoccerNft1,
      ...mybattlePetNft1,
      ...myweaponNft1,
      ...mypetEggNft1
    ]
    console.log("---allMyAsks1--",allMyAsks1)
    setAllMyAsks1(allMyAsks1)
    setRequestedList1(true)
    if(allMyAsks1.length){
      fetchDataV1(allMyAsks1)
    }else{
      setAllMyMostAsksApi1([])
    }
  }, [account])

  const getMyAllAsks2 = useCallback(async () => {
    let mybscArtistsAsks1 = await bscArtistsAsks1()
    mybscArtistsAsks1 = mybscArtistsAsks1.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.BAKERYARTWORK,
        nftType: 3,
        ids: '3-' + d[0]
      }
    })
    let mybscArtistsAsks2 = await bscArtistsAsks2()
    mybscArtistsAsks2 = mybscArtistsAsks2.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.BAKERYBSCARTWORK,
        nftType: 111,
        ids: '111-' + d[0]
      }
    })
    let mykakaNft = await kakaNft()
    mykakaNft = mykakaNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETMULTITOKEN.KAKAMULTITOKEN,
        nftType: 116,
        ids: '116-' + d[0]
      }
    })
    let myradioCacaNft1 = await radioCacaNft1()
    myradioCacaNft1 = myradioCacaNft1.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.RACANFT,
        nftType: 107,
        ids: '107-' + d[0]
      }
    })
    let myradioCacaNft2 = await radioCacaNft2()
    myradioCacaNft2 = myradioCacaNft2.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETMULTITOKEN.RACAMULTITOKEN,
        nftType: 107,
        ids: '107-' + d[0]
      }
    })
    let myradioCacaNft3 = await radioCacaNft3()
    myradioCacaNft3 = myradioCacaNft3.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETMULTITOKEN.MATRIXMULTITOKEN,
        nftType: 113,
        ids: '113-' + d[0]
      }
    })
    let myradioCacaNft4 = await radioCacaNft4()
    myradioCacaNft4 = myradioCacaNft4.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETMULTITOKEN.BAKEMUSKMIXERMULTITOKEN,
        nftType: 117,
        ids: '117-' + d[0]
      }
    })
    let mytokauNft = await tokauNft()
    mytokauNft = mytokauNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETMULTITOKEN.TOKAUMULTITOKEN,
        nftType: 112,
        ids: '112-' + d[0]
      }
    })
    let myloveNft = await loveNft()
    myloveNft = myloveNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.LOVE,
        nftType: 105,
        ids: '105-' + d[0]
      }
    })
    let mysafeNft = await safeNft()
    mysafeNft = mysafeNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.SFPARTWORK,
        nftType: 101,
        ids: '101-' + d[0]
      }
    })
    let mymuskNft = await muskNft()
    mymuskNft = mymuskNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.MUSKDOGE,
        nftType: 4,
        ids: '4-' + d[0]
      }
    })
    let myinchNft = await inchNft()
    myinchNft = myinchNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.ONEINCH,
        nftType: 8,
        ids: '8-' + d[0]
      }
    })
    let mybananaNft = await bananaNft()
    mybananaNft = mybananaNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.MEME,
        nftType: 5,
        ids: '5-' + d[0]
      }
    })
    let mybtcNft = await btcNft()
    mybtcNft = mybtcNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.BTCARTWORK,
        nftType: 1,
        ids: '1-' + d[0]
      }
    })
    let myseascapeNft = await seascapeNft()
    myseascapeNft = myseascapeNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.SEASCAPE,
        nftType: 6,
        ids: '6-' + d[0]
      }
    })
    let mybinanceNft = await binanceNft()
    mybinanceNft = mybinanceNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.BINANCENFT,
        nftType: 2,
        ids: '2-' + d[0]
      }
    })
    let mytkoNft = await tkoNft()
    mytkoNft = mytkoNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.TKONFT,
        nftType: 7,
        ids: '7-' + d[0]
      }
    })
    let myyooshiNft = await yooshiNft()
    myyooshiNft = myyooshiNft.map(d => {
      return {
        id: d[0],
        version: 2,
        marketType: MARKETTYPE.YOOSHINFT,
        nftType: 109,
        ids: '109-' + d[0]
      }
    })
    let mybondlyNft = await bondlyNft()
    mybondlyNft = mybondlyNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.BONDLYNFT,
        nftType: 110,
        ids: '110-' + d[0]
      }
    })
    let mytoyNft = await toyNft()
    mytoyNft = mytoyNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETMULTITOKEN.TOYMULTITOKEN,
        nftType: 115,
        ids: '115-' + d[0]
      }
    })
    let mydoggyNft = await doggyNft()
    mydoggyNft = mydoggyNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.DOGGYNFT,
        nftType: 104,
        ids: '104-' + d[0]
      }
    })
    let mybarkingNft = await barkingNft()
    mybarkingNft = mybarkingNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.BARKNFT,
        nftType: 108,
        ids: '108-' + d[0]
      }
    })
    let mydoggyEquipmentNft = await doggyEquipmentNft()
    mydoggyEquipmentNft = mydoggyEquipmentNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETMULTITOKEN.EQUIPMENTMULTITOKEN,
        nftType: 114,
        ids: '114-' + d[0]
      }
    })
    let mypokerNft = await pokerNft()
    mypokerNft = mypokerNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETMULTITOKEN.POKERMULTITOKEN,
        nftType: 106,
        ids: '106-' + d[0]
      }
    })
    let mycarNft = await carNft()
    mycarNft = mycarNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.CARNFT,
        nftType: 103,
        ids: '103-' + d[0]
      }
    })
    let mycomboNft = await comboNft()
    mycomboNft = mycomboNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.DISH,
        nftType: 10,
        ids: '10-' + d[0]
      }
    })
    let mysoccerNft = await soccerNft()
    mysoccerNft = mysoccerNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.BAKERYSOCCER,
        nftType: 100,
        ids: '100-' + d[0]
      }
    })
    let mybattlePetNft = await battlePetNft()
    mybattlePetNft = mybattlePetNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.PETNFT,
        nftType: 13,
        ids: '13-' + d[0]
      }
    })
    let myweaponNft = await weaponNft()
    myweaponNft = myweaponNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.WEAPONNFT,
        nftType: 12,
        ids: '12-' + d[0]
      }
    })
    let mypetEggNft = await petEggNft()
    mypetEggNft = mypetEggNft.map(d => {
      return {
        id: d[0], 
        version: 2,
        marketType: MARKETTYPE.EGGNFT,
        nftType: 11,
        ids: '11-' + d[0]
      }
    })
    const allMyAsks2 = [
      ...mybscArtistsAsks1,
      ...mybscArtistsAsks2,
      ...mykakaNft,
      ...myradioCacaNft1,
      ...myradioCacaNft2,
      ...myradioCacaNft3,
      ...myradioCacaNft4,
      ...mytokauNft,
      ...myloveNft,
      ...mysafeNft,
      ...mymuskNft,
      ...myinchNft,
      ...mybananaNft,
      ...mybtcNft,
      ...myseascapeNft,
      ...mybinanceNft,
      ...mytkoNft,
      ...myyooshiNft,
      ...mybondlyNft,
      ...mytoyNft,
      ...mydoggyNft,
      ...mybarkingNft,
      ...mydoggyEquipmentNft,
      ...mypokerNft,
      ...mycarNft,
      ...mycomboNft,
      ...mysoccerNft,
      ...mybattlePetNft,
      ...myweaponNft,
      ...mypetEggNft
    ]
    console.log("---allMyAsks2--",allMyAsks2)
    setAllMyAsks2(allMyAsks2)
    setRequestedList2(true)
    if(allMyAsks2.length){
      fetchDataV2(allMyAsks2)
    }else{
      setAllMyMostAsksApi2([])
    }
  }, [account])

  const fetchDataV1 = async (allMyAsks1:Array<any>) => {
    fetchV1MostArtworks(allMyAsks1)
    fetchV1PetArtworks(allMyAsks1)
    fetchV1WeaponArtworks(allMyAsks1)
    fetchV1EggArtworks(allMyAsks1)
    fetchV1ComboArtworks(allMyAsks1)
  }

  const fetchV1MostArtworks = async (allMyAsks1:Array<any>) => {
    let ids = allMyAsks1.map(d => {
      return d && d.ids
    })
    let nftTypes = allMyAsks1.map(d => {
      return d && d.nftType
    })
    nftTypes = [...new Set(nftTypes )]
    let params = {
      ids: ids.join(","),
      nftTypes: nftTypes.join(","),
      fileType: "",
      sortBy: "desc",
      sortName: "blockCreateTime",
      status: 1
    }
    if(!ids.length){
      setAllMyMostAsksApi1([])
    }else{
      getArtworks(chainId as number, params, (err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        const dataAry = data.data.list || []
        const allMyAsksV1 = dataAry.map((d: any) => {
          return {
            id: d.id,
            fileType: d.fileType,
            nftType: d.nftType,
            marketType: userMarketNameAll(d.nftType),
            version: 2,
            cover_url: d.attributes.cover_url,
            fileUrl: d.fileUrl
          }
        })
        setAllMyMostAsksApi1(allMyAsksV1)
      })
    }
  }

  const fetchV1PetArtworks = async (allMyAsks1:Array<any>) => {
    let ids = allMyAsks1.filter(d => {
      return d.nftType === 13
    }).map(d => {
      return d && d.id
    })
    let params = {
      ids: ids.join(","),
      sortName: 'price',
      sortBy: 'asc'
    }
    if(!ids.length){
      setAllMyPetAsksApi1([])
    }else{
      getPets(chainId as number, params, (err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        let dataAry = data.data.list || []
        const allMyPetAsksV1 = dataAry.map(async (d: any) => {
          const helmet = d.helmet && helmetNftContract ? await getHelmetInfo(helmetNftContract, +d.helmet) : undefined
          const weapon = d.weapon && weaponNftContract ? await getWeaponInfo(weaponNftContract, d.weapon) : undefined
          const petUrl = getPetImageUrl({
            petType: d.petType,
            weaponType: weapon ? weapon.weaponType.toString() : 0,
            weaponLevel: weapon ? weapon.level.toString() : 0,
            helmetType: helmet ? helmet.helmetType.toNumber() + 1 : 0,
            helmetLevel: helmet ? helmet.level.toNumber() : 0
          })
          return {
            id: '13-' + d.id,
            fileType: 1,
            nftType: 13,
            marketType: userMarketNameAll('13'),
            version: 1,
            cover_url: '',
            fileUrl: process.env.REACT_APP_PETS_URL + PET_BASE_URL + petUrl
          }
        })
        setAllMyPetAsksApi1(allMyPetAsksV1)
      })
    }
    
  }

  const fetchV1WeaponArtworks = async (allMyAsks1:Array<any>) => {
    let ids = allMyAsks1.filter(d => {
      return d.nftType === 12
    }).map(d => {
      return d && d.id
    })
    let params = {
      ids: ids.join(","),
    }
    if(!ids.length){
      setAllMyWeaponAsksApi1([])
    }else{
      getWeapons(chainId as number, params, async (err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        let dataAry = data.data.list || []
        const allMyWeaponAsksV1 = dataAry.map((d: any) => {
          return {
            id: '12-' + d.id,
            fileType: 1,
            nftType: 12,
            marketType: userMarketNameAll('12'),
            version: 1,
            cover_url:'',
            fileUrl: '/images/weapons/bunny/' + (d.level * 1 - 1) + '.svg'
          }
        })
        setAllMyWeaponAsksApi1(allMyWeaponAsksV1)
      })
    }
  }

  const fetchV1EggArtworks = async (allMyAsks1:Array<any>) => {
    let ids = allMyAsks1.filter(d => {
      return d.nftType === 11
    }).map(d => {
      return d && d.id
    })
    let params = {
      ids: ids.join(","),
    }
    if(!ids.length){
      setAllMyEggAsksApi1([])
    }else{
      getPetEggs(chainId as number, params, async (err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        let dataAry = data.data.list || []
        const allMyEggAsksV1 = dataAry.map((d: any) => {
          const featuresLen = 4
          const eggTypeLimit = 3
          const emotionsLimit = 5
          const hatsLimit = 7
          const eggId = d.tokenId ? Number(d.tokenId) : 0
          const petType = new BigNumber(supportPetType.includes(d.petType) ? d.petType : PetType.kitten)
            .minus(1)
            .mod(eggTypeLimit)
            .integerValue()
            .toString(2)
          const emotions = new BigNumber(eggId)
            .mod(emotionsLimit)
            .integerValue()
            .toString(2)
          const hats = new BigNumber(eggId)
            .mod(hatsLimit)
            .integerValue()
            .toString(2)
          const petTypeBinary = Array.from(Array(featuresLen - petType.length).keys()).map(() => '0').join('') + petType
          const emotionsBinary = Array.from(Array(featuresLen - emotions.length).keys()).map(() => '0').join('') + emotions
          const hatsBinary = Array.from(Array(featuresLen - hats.length).keys()).map(() => '0').join('') + hats
          const eggImageUrl = petTypeBinary + emotionsBinary + hatsBinary + '.svg'
          
          return {
            id: '11-' + d.id,
            fileType: 1,
            nftType: 11,
            marketType: userMarketNameAll('11'),
            version: 1,
            cover_url:'',
            fileUrl: process.env.REACT_APP_PETS_URL + '/api/eggs/mdkeuhvm/' + eggImageUrl
          }
        })
        setAllMyEggAsksApi1(allMyEggAsksV1)
      })
    }
  }
  const fetchV1ComboArtworks = async (allMyAsks1:Array<any>) => {
    let ids = allMyAsks1.filter(d => {
      return d.nftType === 10
    }).map(d => {
      return d && d.id
    })
    let params = {
      ids: ids.join(","),
    }
    if(!ids.length){
      setAllMyComboAsksApi1([])
    }else{
      getBakeryCombos(chainId as number, params, async (err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        let dataAry = data.data.list || []
        const allMyComboAsksV1 = dataAry.map((d: any) => {
          let dishIcon = d.items
          .map((s: string | number) => {
            const valBinary = new BigNumber(s)
              .div(100000)
              .integerValue(BigNumber.ROUND_FLOOR)
              .toString(2)
            return valBinary.length < 2 ? '0' + valBinary : valBinary
          })
          .join('') + '.svg'
          return {
            id: '10-' + d.id,
            fileType: 1,
            nftType: 10,
            marketType: userMarketNameAll('10'),
            version: 1,
            cover_url:'',
            fileUrl: (process.env.REACT_APP_DISH_URL ?? '') + '/api/set0001/' + dishIcon
          }
        })
        setAllMyComboAsksApi1(allMyComboAsksV1)
      })
    }
  }

  const fetchDataV2 = async (allMyAsks2:Array<any>) => {
    fetchV2MostArtworks(allMyAsks2)
    fetchV2PetArtworks(allMyAsks2)
    fetchV2WeaponArtworks(allMyAsks2)
    fetchV2EggArtworks(allMyAsks2)
    fetchV2ComboArtworks(allMyAsks2)
  }

  const fetchV2MostArtworks = async (allMyAsks2:Array<any>) => {
    let ids = allMyAsks2.map(d => {
      return d && d.ids
    })
    let nftTypes = allMyAsks2.map(d => {
      return d && d.nftType
    })
    nftTypes = [...new Set(nftTypes )]
    let params = {
      ids:  ids.join(","),
      nftTypes: nftTypes.join(","),
      fileType: "",
      sortBy: "desc",
      sortName: "blockCreateTime",
      status: 1
    }
    if(!ids.length){
      setAllMyMostAsksApi2([])
    }else{
      getArtworksV2(chainId as number, params, (err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        const dataAry = data.data.list || []
        const allMyAsksV2 = dataAry.map((d: any) => {
          return {
            id: d.id,
            fileType: d.fileType,
            nftType: d.nftType,
            marketType: userMarketNameAll(d.nftType),
            version: 2,
            cover_url: d.attributes.cover_url,
            fileUrl: d.fileUrl
          }
        })
        setAllMyMostAsksApi2(allMyAsksV2)
      })
    }
   
  }

  const fetchV2PetArtworks = async (allMyAsks2:Array<any>) => {
    let ids = allMyAsks2.filter(d => {
      return d.nftType === 13
    }).map(d => {
      return d && d.id
    })
    let params = {
      ids: ids.join(","),
      sortName: 'price',
      sortBy: 'asc'
    }
    if(!ids.length){
      setAllMyPetAsksApi2([])
    }else{
      getPetsV2(chainId as number, params, async (err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        let dataAry = data.data.list || []
        const allMyPetAsksV2 = await Promise.all(
          dataAry.map(async (d: any) => {
            const helmet = d.helmet && helmetNftContract ? await getHelmetInfo(helmetNftContract, +d.helmet) : undefined
            const weapon = d.weapon && weaponNftContract ? await getWeaponInfo(weaponNftContract, d.weapon) : undefined
            const petUrl = getPetImageUrl({
              petType: d.petType,
              weaponType: weapon ? weapon.weaponType.toString() : 0,
              weaponLevel: weapon ? weapon.level.toString() : 0,
              helmetType: helmet ? helmet.helmetType.toNumber() + 1 : 0,
              helmetLevel: helmet ? helmet.level.toNumber() : 0
            })
            return {
              id: '13-' + d.id,
              fileType: 1,
              nftType: 13,
              marketType: userMarketNameAll('13'),
              version: 2,
              cover_url: '',
              fileUrl: process.env.REACT_APP_PETS_URL + PET_BASE_URL + petUrl
            }
          })
        )
        setAllMyPetAsksApi2(allMyPetAsksV2)
      })
    }
  }

  const fetchV2WeaponArtworks = async (allMyAsks2:Array<any>) => {
    let ids = allMyAsks2.filter(d => {
      return d.nftType === 12
    }).map(d => {
      return d && d.id
    })
    let params = {
      ids: ids.join(","),
    }
    if(!ids.length){
      setAllMyWeaponAsksApi2([])
    }else{
      getWeaponsV2(chainId as number, params, async (err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        let dataAry = data.data.list || []
        const allMyWeaponAsksV2 = dataAry.map((d: any) => {
          return {
            id: '12-' + d.id,
            fileType: 1,
            nftType: 12,
            marketType: userMarketNameAll('12'),
            version: 2,
            cover_url: '',
            fileUrl: '/images/weapons/bunny/' + (d.level * 1 - 1) + '.svg'
          }
        })
        setAllMyWeaponAsksApi2(allMyWeaponAsksV2)
      })
    }
  }

  const fetchV2EggArtworks = async (allMyAsks2:Array<any>) => {
    let ids = allMyAsks2.filter(d => {
      return d.nftType === 11
    }).map(d => {
      return d && d.id
    })
    let params = {
      ids: ids.join(","),
    }
    console.log("----id----",ids)
    if(!ids.length){
      setAllMyEggAsksApi2([])
    }else{
      getPetEggsV2(chainId as number, params, async (err: any, data: any) => {
        console.log("----false  enter----")
        if (err) return
        if (data.code !== 0) return
        let dataAry = data.data.list || []
        const allMyEggAsksV2 = dataAry.map((d: any) => {
          const featuresLen = 4
          const eggTypeLimit = 3
          const emotionsLimit = 5
          const hatsLimit = 7
          const eggId = d.tokenId ? Number(d.tokenId) : 0
          const petType = new BigNumber(supportPetType.includes(d.petType) ? d.petType : PetType.kitten)
            .minus(1)
            .mod(eggTypeLimit)
            .integerValue()
            .toString(2)
          const emotions = new BigNumber(eggId)
            .mod(emotionsLimit)
            .integerValue()
            .toString(2)
          const hats = new BigNumber(eggId)
            .mod(hatsLimit)
            .integerValue()
            .toString(2)
          const petTypeBinary = Array.from(Array(featuresLen - petType.length).keys()).map(() => '0').join('') + petType
          const emotionsBinary = Array.from(Array(featuresLen - emotions.length).keys()).map(() => '0').join('') + emotions
          const hatsBinary = Array.from(Array(featuresLen - hats.length).keys()).map(() => '0').join('') + hats
          const eggImageUrl = petTypeBinary + emotionsBinary + hatsBinary + '.svg'
          
          return {
            id: '11-' + d.id,
            fileType: 1,
            nftType: 11,
            marketType: userMarketNameAll('11'),
            version: 2,
            cover_url: '',
            fileUrl: process.env.REACT_APP_PETS_URL + '/api/eggs/mdkeuhvm/' + eggImageUrl
          }
        })
        setAllMyEggAsksApi2(allMyEggAsksV2)
      })
    }
  }

  const fetchV2ComboArtworks = async (allMyAsks2:Array<any>) => {
    let ids = allMyAsks2.filter(d => {
      return d.nftType === 10
    }).map(d => {
      return d && d.id
    })
    let params = {
      ids: ids.join(","),
    }
    if(!ids.length){
      setAllMyComboAsksApi2([])
    }else{
      getBakeryCombosV2(chainId as number, params, async (err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        let dataAry = data.data.list || []
        const allMyComboAsksV2 = dataAry.map((d: any) => {
          let dishIcon = d.items
          .map((s: string | number) => {
            const valBinary = new BigNumber(s)
              .div(100000)
              .integerValue(BigNumber.ROUND_FLOOR)
              .toString(2)
            return valBinary.length < 2 ? '0' + valBinary : valBinary
          })
          .join('') + '.svg'
          return {
            id: '10-' + d.id,
            fileType: 1,
            nftType: 10,
            marketType: userMarketNameAll('10'),
            version: 2,
            cover_url: '',
            fileUrl: (process.env.REACT_APP_DISH_URL ?? '') + '/api/set0001/' + dishIcon
          }
        })
        setAllMyComboAsksApi2(allMyComboAsksV2)
      })
    }
    
  }

  useEffect(() => {
    getMyAllAsks1()
    getMyAllAsks2()
  }, [getMyAllAsks1, getMyAllAsks2])

  useEffect(() => {
    const all = [...allMyAsks1, ...allMyAsks2]
    if(all.length){
      setHasList(true)
    }else{
      setHasList(false)
    }
    setAllMyAsks(all)
  }, [allMyAsks1, allMyAsks2])

  useEffect(() => {
    const allapi = [
      ...allMyMostAsksApi1,
      ...allMyMostAsksApi2,
      ...allMyPetAsksApi1,
      ...allMyPetAsksApi2,
      ...allMyWeaponAsksApi1,
      ...allMyWeaponAsksApi2,
      ...allMyEggAsksApi1,
      ...allMyEggAsksApi2,
      ...allMyComboAsksApi1,
      ...allMyComboAsksApi2,
    ]
    console.log("--allapi--",allapi)
    setAllMyAsksApi(allapi)
  }, [
    allMyMostAsksApi1, 
    allMyMostAsksApi2,
    allMyPetAsksApi1,
    allMyPetAsksApi2,
    allMyWeaponAsksApi1,
    allMyWeaponAsksApi2,
    allMyEggAsksApi1,
    allMyEggAsksApi2,
    allMyComboAsksApi1,
    allMyComboAsksApi2,
  ])

  const handleRevoke = useCallback(async () => {
    allMyAsks.map(async (d) => {
      try {
        let exchangeNFTContract: any
        let isMultiTokenNft = false
        if(d.marketType && MARKETTYPEV1.hasOwnProperty(d.marketType)){
          exchangeNFTContract = userExchangeNFTContract(sushi, d.marketType)
          isMultiTokenNft = false
        }else if(d.marketType && MARKETTYPE.hasOwnProperty(d.marketType)){
          exchangeNFTContract = userBidNFTContract(sushi, d.marketType)
          isMultiTokenNft = false
        }else if(d.marketType && MARKETMULTITOKEN.hasOwnProperty(d.marketType)){
          exchangeNFTContract = multiTokenExchangeNftContract(sushi, d.marketType)
          isMultiTokenNft = true
        }
        let txHash
        if(!isMultiTokenNft){
          txHash = await cancelSellToken(
            exchangeNFTContract,
            d.id,
            account
          )
        }else {
          let nftAddress = userNftAddress(sushi, d.marketType)
          txHash = await exchangeNFTsCancelSellToken(
            exchangeNFTContract,
            nftAddress,
            d.id,
            account
          )
        }
        onDismiss && onDismiss()
        return txHash
      } catch (e) {
        onDismiss && onDismiss()
        return false
      }
    })
  },[allMyAsks,userExchangeNFTContract,userBidNFTContract,multiTokenExchangeNftContract,cancelSellToken,userNftAddress,exchangeNFTsCancelSellToken])

  return (
    <Modal maxWidth={623} backgroundColor={'#FFF3E0'}>
      <ModalTitle text={'Revoke from V1V2  NFT Marketplace'} />
      {
        (!requestedList1 ||  !requestedList2) && (
          <ItemSearchBtn>Searching
            <img src='/images/nft/loading.png'/>
          </ItemSearchBtn>
        )
      }
      {
        hasList && requestedList1 && requestedList2 && (
          <ItemBtn
          onClick={handleRevoke}
          >Revoke All</ItemBtn>
        ) 
      }
      {
        !hasList && requestedList1 && requestedList2 && (
          <ItemSearchBtn>
            You dont have nfts on sale
          </ItemSearchBtn>
        ) 
      }
      <Content>
        <ArtworkLists>
          {
            allMyAsksApi.map((d) => {
              return (
                <ArtworkItem
                  key={d.id}
                >
                  <VersionIcon src={'/images/nft/v' + d.version + 'icon.png'}></VersionIcon>
                  {
                    d.fileType === 3 ? d.cover_url ? (
                      <IconArtwork src={d.cover_url} alt="video"/>
                    ) : (
                      <VideoArtwork src={d.fileUrl}>
                        您的浏览器不支持 video 标签。
                      </VideoArtwork>
                    )
                    : d.fileType === 4 ? (
                      <IconArtwork src={d.cover_url} alt="audio"/>
                    ) : (
                      <IconArtwork src={d.fileUrl} alt="image"/>
                    )
                  }
                  <MarketLabel>
                    <MarketIcon src={'/images/nft/marketIcon.png'}></MarketIcon>
                    <MarketName>{d.marketType}</MarketName>
                  </MarketLabel>
                </ArtworkItem>
              )
            })
          }
        </ArtworkLists>
      </Content>
    </Modal>
  )
}

export default RevokeAllModal
